import APIService from '../api.service';

export const All = (params) => {
  const endpoint = params.is_sale ? `/v01/sales` : `/v01/orders`;
  return APIService.get(endpoint, {
    params: {
      per_page: params.perPage,
      page: params.page,
      keyword: params.keyword,
      order_date: params.order_date,
      shop_id: params.shop_id,
      warehouse_id: params.warehouse_id,
      region_id: params.region_id,
      status: params.status,
      statuses: params.statuses,
      from_date: params.fromDate,
      to_date: params.toDate,
      is_sale: params.is_sale || false,
    },
  });
};

export const ExportSales = (params) => {
  return APIService.get(`/v01/orders/sales/export`, {
    params: {
      keyword: params.keyword,
      shop_id: params.shop_id,
      from_date: params.fromDate,
      to_date: params.toDate,
    },
    responseType: 'blob',
  });
};

export const Details = (id, isSale = false) => {
  return APIService.get(`/v01/${isSale ? 'sales' : 'orders'}/${id}`);
};

export const UpdateStatues = (payload, config = {}) => {
  return APIService.put(`/v01/update-order-statuses`, { ...payload }, config);
};

export const UpdateOrderItem = (payload, config = {}) => {
  return APIService.put(`/v01/update-order-items`, { ...payload }, config);
};

export const UpdateReceivedOrderItem = (id, payload, config = {}) => {
  return APIService.put(`/v01/order-items/${id}/received`, { ...payload }, config);
};

export const DeleteOrderItem = (id, config = {}) => {
  return APIService.delete(`/v01/order-items/${id}`, config);
};

export const fetchItemListByAdmin = (params) => {
  return APIService.get(`/v01/items-by-admin`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      category_id: params.category_id,
      shop_id: params.shop_id,
      order_id: params.order_id,
      keyword: params.keyword,
    },
  });
}

export const createOrder = (payload, config = {}) => {
  return APIService.post(`/v01/shop/create-order`, { ...payload }, config);
};

export const cloneOrder = (id, config = {}) => {
  return APIService.post(`/v01/orders/${id}/clone`, {}, config);
};

export const addItemToOrder = (orderId, payload, config = {}) => {
  return APIService.post(`/v01/orders/${orderId}/add-item`, { ...payload }, config);
};

const OrderService = {
  All,
  ExportSales,
  Details,
  UpdateStatues,
  UpdateOrderItem,
  UpdateReceivedOrderItem,
  DeleteOrderItem,
  fetchItemListByAdmin,
  createOrder,
  cloneOrder,
  addItemToOrder,
}

export default OrderService;